import React from 'react';
import { QueryClient, QueryClientProvider, useQuery } from 'react-query'

const AutoQuery = ({getData}) => {
  const { isLoading, isError, data, error } = useQuery('data', () => getData)
  //console.log("AutoQuery", isLoading, isError, data, error)
  return null
}

export default AutoQuery;